<template>
<div id="create-provider">
  <h2>Create Provider</h2>

  <provider-nav />

  <provider-form></provider-form>
</div>
</template>

<script>
import ProviderForm from '@/components/ProviderForm'
import ProviderNav from '@/components/ProviderNav'

export default {
  components: {
    'provider-form': ProviderForm,
    'provider-nav': ProviderNav
  },

  methods: {
    processErrors (resp) {
      this.$parent.processErrors(resp)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ProviderCreate.vue